import { put, takeLatest } from 'redux-saga/effects';
import { getUserSavedSearch } from "@/api/home";
import { fetchSavedSearchFailure, fetchSavedSearchSuccess } from "./savedSearchSlice";

export function* fetchSavedSearchesSaga(action) {
  const response = yield getUserSavedSearch(action.payload);
  if (response) {
    yield put(fetchSavedSearchSuccess(response));
  } else {
    yield put(fetchSavedSearchFailure(response));
  }
}

export function* watchSavedSearchesSaga() {
  yield takeLatest('savedSearch/fetchSavedSearch', fetchSavedSearchesSaga);
}